export default __webpack_public_path__ + "static/media/P400MANC5.f2cd365c.pdf";